import React from 'react';
import { Route, Switch } from 'react-router';

import { MessengerLogin, StarsHelp } from '@swf/help';

const HelpModalRoutes: React.FC = () => (
  <Switch>
    <Route path="/help/contact" component={StarsHelp} />
    <Route path="/help/messenger" component={MessengerLogin} />
  </Switch>
);

export default HelpModalRoutes;
